import { createResourceStore, type FetchOptions } from "@/lib/resource";
import type { Shop } from "./Shop";
import { apiClient } from "@/lib/http";
import { useAuth } from "./Auth";
import { pick } from "@/lib/utils";

export interface FinanceAccount {
  id: string;
  name: string;
  type: "cash" | "bank" | "orange_money" | "momo" | "crypto";
  shop_id: string | null;
  account_number: string | null;
  currency: string; // default 'XAF'
  status: string;
  balance: number;
  description: string | null;
  meta: Record<string, any>;
  shop: Shop;
  created_at: string;
  updated_at: string;
}

export interface PaymentInfo {
  finance_account_id: string | "debt";
  amount: number;
  due_date: Date | string;
  payment_date: Date | string;
  amount_given: number; // when type == cash
  change_given: number; // when type == cah
}

export const useFinanceAccount = createResourceStore<FinanceAccount>(
  "finance-accounts",
  (_set, get) => ({
    fetch: (
      params: any = { page: 1, per_page: 15 },
      options: FetchOptions = { save: true }
    ) => {
      const session = useAuth.getState().session;

      return apiClient()
        .get(`finance-accounts`, {
          params: {
            shop_id: session?.currentShop?.id,
            business_id: session?.business?.id,
            status: "active",
            ...params,
          },
        })
        .then((res) => {
          if (options.save) {
            get().setItems(res.data);
            get().setResult(res.data);
            get().paginate(res.data, pick(params, ["page", "per_page"]));
          }

          return Promise.resolve(res.data);
        });
    },
  })
);
